import { render, staticRenderFns } from "./VideoHotspot.vue?vue&type=template&id=1c64c563&scoped=true&"
import script from "./VideoHotspot.vue?vue&type=script&lang=js&"
export * from "./VideoHotspot.vue?vue&type=script&lang=js&"
import style0 from "./VideoHotspot.vue?vue&type=style&index=0&id=1c64c563&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c64c563",
  null
  
)

export default component.exports